


import React, { useState } from "react";

const gallery = [
  {
    id: 1,
    name: "",
    seats: "4 Seater",
    image: "/images/fleets/1.jpeg",
  },
  {
    id: 2,
    name: "",
    seats: "7 Seater",
    image: "/images/fleets/2.jpeg",
  },
    {
    id: 2,
    name: "",
    seats: "7 Seater",
    image: "/images/fleets/3.jpg",
  },


 {
    id: 2,
    name: "",
    seats: "7 Seater",
    image: "/images/fleets/4.jpeg",
  },
   {
    id: 2,
    name: "",
    seats: "7 Seater",
    image: "/images/fleets/5.jpeg",
  },

  {
    id: 3,
    name: "Force Urbania",
    seats: "13 Seater",
    image: "/images/fleets/Force-Urbania.jpg",
  },
  {
    id: 4,
    name: "17 Seater Tempo Traveller",
    seats: "17 Seater",
    image: "/images/fleets/17-Seater-Tempo-Traveller.jpg",
  },
  {
    id: 5,
    name: "20 Seater Tempo Traveller",
    seats: "20 Seater",
    image: "/images/fleets/20-Seater-Tempo-Traveller.jpg",
  },
  {
    id: 6,
    name: "32 Seater Bus",
    seats: "32 Seater",
    image: "/images/fleets/32-Seater-Bus.jpg",
  },
  {
    id: 7,
    name: "35 Seater Bus",
    seats: "35 Seater",
    image: "/images/fleets/35-Seater-Bus.jpg",
  },
  {
    id: 8,
    name: "40 Seater Bus",
    seats: "40 Seater",
    image: "/images/fleets/40-Seater-Bus.jpg",
  },
  {
    id: 9,
    name: "45 Seater AC Bus",
    seats: "45 Seater",
    image: "/images/fleets/45-Seater-AC-Bus.jpg",
  },
  {
    id: 1,
    name: "Hyundai Aura",
    seats: "4 Seater",
    image: "/images/fleets/Hyundai-Aura.jpg",
  },
  {
    id: 2,
    name: "Maruti Suzuki Ertiga",
    seats: "7 Seater",
    image: "/images/fleets/Maruti-Suzuki-Ertiga.jpg",
  },
];
const Gallery = () => {
  const [currentIndex, setCurrentIndex] = useState(null);

  const openImage = (index) => {
    setCurrentIndex(index);
  };

  const closeImage = () => {
    setCurrentIndex(null);
  };

  const nextImage = () => {
    setCurrentIndex((prev) =>
      prev === gallery.length - 1 ? 0 : prev + 1
    );
  };

  const prevImage = () => {
    setCurrentIndex((prev) =>
      prev === 0 ? gallery.length - 1 : prev - 1
    );
  };

  return (
    <>


      
             <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  Gallery
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container py-5">
        <div className="row">
          {gallery.map((item, index) => (
            <div key={item.id} className="col-lg-4 col-md-6 mb-4 ">
              <div className="gallery-card borderr" onClick={() => openImage(index)}>
                <img src={item.image} alt={item.name} />
                <h5>{item.name}</h5>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* LIGHTBOX */}
      {currentIndex !== null && (
        <div className="lightbox">
          <span className="close darkcolorrrr" onClick={closeImage}>✖</span>

          <span className="prev" onClick={prevImage}>❮</span>
          <img
            src={gallery[currentIndex].image}
            alt="preview"
            className="lightbox-img "
          />
          <span className="next" onClick={nextImage}>❯</span>
        </div>
      )}
    </>
  );
};

export default Gallery;